

























































	import AbpBase from "../../../lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  InsertAssayCategoryItem,
  UpdateAssayCategoryItem,
  GetAssayCategoryItem,
} from "../../../api/basicDictionary";
import { QueryAssayItems } from "@/api/assay";
@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;
  form: any = {
    itemCode: "",
    itemName: "",
    otherValue: "",
    unit: "",
  };
  dialogTitle: string = "";
  rules = {
    itemCode: [{ required: true, message: "请输入内容", trigger: "blur" }],
    itemName: [{ required: true, message: "请输入内容", trigger: "blur" }],
  };
  itemsPageRequest = {
    page: 1,
    pageSize: 10,
    queryString: "",
  };
  itemColumns = [
    {
      key: "itemCode",
      title: "指标编码",
    },
    {
      key: "itemName",
      title: "指标名称",
    },
    {
      key: "groupName",
      title: "化验项目",
    },
    {
      key: "otherValue",
      title: "参考值",
    },
    {
      key: "unit",
      title: "单位",
    },
    {
      title: "操作",
      width: 100,
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: () => {
                  this.loadItem(p.row);
                },
              },
            },
            "载入"
          ),
        ]);
      },
    },
  ];
  itemsData = [];
  itemsLoading = false;
  itemsTableTotalSize = 0;
  itemsQueryString: string = "";

  query() {
    this.itemsPageRequest.page = 1;
    this.getItemsData();
  }

  async getItemsData() {
    this.itemsLoading = true;
    let res = await QueryAssayItems(this.itemsPageRequest);
    this.itemsLoading = false;
    this.itemsData = res.items;
    this.itemsTableTotalSize = res.totalCount;
  }

  itemsPageChange(val: any) {
    this.itemsPageRequest.page = val;
    this.getItemsData();
  }

  loadItem(row: any) {
    this.form.itemCode = row.itemCode;
    this.form.itemName = row.itemName;
    this.form.otherValue = row.otherValue;
    this.form.unit = row.unit;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      (this.$refs.form as any).resetFields();
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  created() {
    if (this.data.mode === "add") {
      this.dialogTitle = "新增匹配关键字";
    } else {
      this.dialogTitle = "修改匹配关键字";
      this.itemsPageRequest.queryString = this.data.item.itemName;
      this.query();
    }
    this.getData();
  }

  async confirm() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.data.mode === "add") {
          await InsertAssayCategoryItem(this.form);
        } else {
          await UpdateAssayCategoryItem(this.form);
        }
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }

  async getData() {
    if (this.data.item) {
      let res = await GetAssayCategoryItem({ id: this.data.item.id });
      this.form = res.objects;
    } else {
      this.form.categoryId = this.data.categoryId;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayCategory/addOrEditItem.vue